import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import arrow from "Arrow-point_right.svg";
import {
  registrationFieldUpdate,
  postEventAccountFieldValidate,
  checkAccountExists,
  contractSubmit,
  setRole,
  HEAR_ABOUT_US_OPTIONS,
  HEAR_ABOUT_US_ADDITIONAL_OPTIONS,
} from "redux/ducks/Registration";
import PhoneInput from "react-phone-input-2";
import TermsConditionsModal from "components/TermsConditionsModal";

const PostEventAccount = ({
  history,
  updateField,
  user,
  validateField,
  validation,
  checkAccountExists,
  contractSubmit,
  setRole,
}) => {
  useEffect(() => {
    setRole("EventOperator");
    updateField("postEventMasterType", "");
  }, []);

  const onFieldValidate = (field) => {
    validateField(field);
  };

  const onPrevious = (e) => {
    e.preventDefault();
    if (user.postEventMasterType === "contract") {
      history.push("/sign-up/contract/info");
    } else {
      history.push("/");
    }
  };

  const onNext = (e) => {
    e.preventDefault();
    if (!validation.valid) return;

    if (user.postEventMasterType === "contract") {
      contractSubmit(history);
    } else {
      checkAccountExists(history);
    }
  };

  const onFieldChange = (field, triggerValidate) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      updateField(field, ev.currentTarget.value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  const onPhoneNumberChange = (phone) => {
    const phoneNo = phone.length === 1 && phone.at(0) !== '1' ? `1${phone}` : phone;

    updateField("phone", phoneNo);
    onFieldValidate("phone");
  };

  const onTermsChanged = (e) => {
    updateField("terms", e.target.checked);
    validateField("terms");
  };

  const onLongTermClick = (e) => {
    e.preventDefault();
    updateField("postEventMasterType", "contract");
    history.push("/sign-up/post-event/profile")
  }

  const ADDITIONAL_HEAR_OPTIONS = HEAR_ABOUT_US_ADDITIONAL_OPTIONS.filter(op => op !== "Other");

  return (
    <div className="postEventAccount">
      <div className="user-form">
        <form id="accountForm" noValidate onSubmit={(e) => e.preventDefault()}>
          <div className="form-group">
            <label className="required" htmlFor="firstName">
              First Name
            </label>
            <input
              type="text"
              placeholder="John"
              value={user.firstName}
              className={classnames("form-control", {
                "is-invalid": validation.errors.firstName,
              })}
              name="firstName"
              onChange={onFieldChange("firstName")}
              onBlur={onFieldValidate.bind(this, "firstName")}
            />
            <div className="invalid-feedback">
              {validation.errors.firstName}
            </div>
          </div>
          <div className="form-group">
            <label className="required" htmlFor="lastName">
              Last Name
            </label>
            <input
              type="text"
              placeholder="Snow"
              value={user.lastName}
              className={classnames("form-control", {
                "is-invalid": validation.errors.lastName,
              })}
              name="lastName"
              onChange={onFieldChange("lastName")}
              onBlur={onFieldValidate.bind(this, "lastName")}
            />
            <div className="invalid-feedback">{validation.errors.lastName}</div>
          </div>
          <div className="form-group">
            <label className="required" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              placeholder="Email"
              value={user.email}
              className={classnames("form-control", {
                "is-invalid": validation.errors.email,
              })}
              name="email"
              onChange={onFieldChange("email")}
              onBlur={onFieldValidate.bind(this, "email")}
            />
            <div className="invalid-feedback">{validation.errors.email}</div>
          </div>
          <div className="form-group">
            <label className="required" htmlFor="phone">
              Phone
            </label>
            <PhoneInput
              name="phone"
              onlyCountries={["us"]}
              preferredCountries={["us"]}
              enableAreaCodes={false}
              autoFormat={true}
              isValid={!validation.errors.phone}
              inputStyle={{ width: '100%' }}
              placeholder="Enter phone number"
              country='us'
              onlyCountries={['us']}
              onBlur={onFieldValidate.bind(this, "phone")}
              onChange={(newNumber) => onPhoneNumberChange(newNumber)}
              value={user.phone}
            />
            <input
              type="hidden"
              className={classnames("form-control", {
                "is-invalid": validation.errors.phone,
              })}
            />
            <div className="invalid-feedback">{validation.errors.phone}</div>
          </div>
          <div className="form-group">
            <label className="required" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              className={classnames("form-control", {
                "is-invalid": validation.errors.password,
              })}
              placeholder="Password"
              value={user.password}
              name="password"
              onChange={onFieldChange("password")}
              onBlur={onFieldValidate.bind(this, "password")}
            />
            <div className="invalid-feedback">{validation.errors.password}</div>
          </div>
          <div className="form-group">
            <label className="required" htmlFor="passwordConfirmation">
              Confirm password
            </label>
            <input
              type="password"
              className={classnames("form-control", {
                "is-invalid": validation.errors.passwordConfirmation,
              })}
              value={user.passwordConfirmation}
              placeholder="Confirm password"
              name="passwordConfirmation"
              onChange={onFieldChange("passwordConfirmation", true)}
              onBlur={onFieldValidate.bind(this, "passwordConfirmation")}
            />
            <span className="password-disclaimer">Your password needs to be at least 10 characters, and include one uppercase and one lowercase letter plus a special character.</span>
            <div className="invalid-feedback">
              {validation.errors.passwordConfirmation}
            </div>
          </div>
          <div className="form-group">
            <label className="required" htmlFor="hear_about_us">
              How did you hear about us?
            </label>
            <select
              name="hear_about_us"
              className={classnames("form-control", "custom-select", {
                "is-invalid": validation.errors.hearAboutUsSource && !ADDITIONAL_HEAR_OPTIONS.includes(user.hearAboutUsSource),
                empty: !user.hearAboutUsSource,
              })}
              value={user.hearAboutUsSource}
              onChange={onFieldChange("hearAboutUsSource", true)}
              onBlur={onFieldValidate.bind(this, "hearAboutUsSource")}
            >
              <option disabled value=""></option>
              {HEAR_ABOUT_US_OPTIONS.map((option, index) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {!ADDITIONAL_HEAR_OPTIONS.includes(user.hearAboutUsSource) && <div className="invalid-feedback">
              {validation.errors.hearAboutUsSource}
            </div>}
          </div>

          {user.hearAboutUsSource === "Other" && (
            <div className="form-group">
              <input
                type="text"
                value={user.hearAboutUsDetails}
                className={classnames("form-control", {
                  "is-invalid": validation.errors.hearAboutUsDetails,
                })}
                name="hearAboutUsDetails"
                onChange={onFieldChange("hearAboutUsDetails", true)}
                onBlur={onFieldValidate.bind(this, "hearAboutUsDetails")}
              />
            </div>
          )}

          {ADDITIONAL_HEAR_OPTIONS.includes(user.hearAboutUsSource) && (
            <div className="form-group">
              <label className="required" htmlFor="hearAboutUsDetails">
                {user.hearAboutUsSource === "Conference" ? "Event Name" : "Who recommended you?"}
              </label>
              <input
                type="text"
                value={user.hearAboutUsDetails}
                className={classnames("form-control", {
                  "is-invalid": validation.errors.hearAboutUsSource,
                })}
                name="hearAboutUsDetails"
                onChange={onFieldChange("hearAboutUsDetails", true)}
                onBlur={onFieldValidate.bind(this, "hearAboutUsDetails")}
              />
              <div className="invalid-feedback">
                {validation.errors.hearAboutUsSource}
              </div>
            </div>
          )}

          <label className="required checkbox privacy-policy">
            I have read and agree to the{"\n"} <a target="_blank" rel="noopener noreferrer" href="https://go4.io/privacy-policy/">Privacy Policy</a> and <a target="_blank" rel="noopener noreferrer" href="https://go4.io/terms-and-conditions/">Terms and Conditions</a>.
            <input type="checkbox" name="terms" checked={user.terms} onChange={onTermsChanged} />
            <span></span>
          </label>
          <div className="actions">
            <button
              type="button"
              className="btn btn-gray bold-button"
              onClick={onPrevious}
            >
              Previous
            </button>
            <button
              type="submit"
              className="btn btn-primary bold-button"
              onClick={onNext}
            >
              Next
            </button>
          </div>
          <div className="login-account">
            <span>
              Have an account?
              <span className="login-link">
                <Link to="/login">Sign in</Link>
              </span>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.registration.user,
    validation: state.registration.postEventAccountValidation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: (field) => dispatch(postEventAccountFieldValidate(field)),
    checkAccountExists: (history) => dispatch(checkAccountExists(history)),
    setRole: (role) => dispatch(setRole(role)),
    contractSubmit: (history) => dispatch(contractSubmit(history)),
  };
}

export { PostEventAccount };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostEventAccount)
);
